module.exports = __webpack_public_path__ + "static/img/Jellyfish.5a44c7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jellyfish.jpg
// module id = 4GHE
// module chunks = 1